import type { IconProps as Props } from './types';

export const IconSpeechBubble = ({ width = 18, height = 17, ...rest }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 9.33402C1 10.6674 1.92144 11.829 3.22113 12.0232C4.09744 12.154 4.98359 12.2557 5.87795 12.3265C6.26031 12.3574 6.61067 12.5607 6.824 12.8857L9 16.2007L11.176 12.8857C11.3893 12.5607 11.7397 12.3574 12.1221 12.3274C13.0164 12.2557 13.9026 12.154 14.7789 12.0232C16.0786 11.829 17 10.6682 17 9.33319V4.31819C17 2.98319 16.0786 1.82235 14.7789 1.62819C12.8654 1.34295 10.934 1.20007 9 1.20069C7.03733 1.20069 5.10749 1.34652 3.22113 1.62819C1.92144 1.82235 1 2.98402 1 4.31819V9.33319V9.33402Z"
        stroke="#1F242E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
